import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
const BreadCrumb = ({ pageName }) => {
	return (
		<ul className='bread-crump'>
			<li>
				<FontAwesomeIcon icon={faHome} />
			</li>
			<li>
				<span>{pageName}</span>
			</li>
		</ul>
	);
};

export default BreadCrumb;
